import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DetailCard = styled(Box, {
  shouldForwardProp: prop => prop !== 'compact',
})(({ theme, compact }) => ({
  backgroundColor: '#484848',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(compact ? 2 : 3),
  width: '100%',
  boxShadow: '0px 1px 2px 0px #64748B1A',
}));
